// import smoothscroll from 'smoothscroll-polyfill'
//smoothscroll.polyfill()
const pages = document.querySelectorAll('.page-preview__wrapper')
if (pages) {
    Array.from(pages)
        .forEach((children) => {
            if (children) {
                // console.log(scrolledP)
                const arrowLeft = children.getElementsByClassName('page-preview__arrow')
                const arrowRight = children.getElementsByClassName('page-preview__arrow-back')
                const nodes = children.getElementsByClassName('page-preview__list')
                const groupNodes = children.getElementsByClassName('page-preview__group')

                if (arrowLeft.length > 0) {
                    let scrolledP = 0
                    const arrowsP = Array.from(arrowLeft)
                    const backsP = Array.from(arrowRight)
                    const pages = Array.from(nodes)
                    // console.log(pages.length)
                    const groups = Array.from(groupNodes)

                    arrowsP.map((arrow, key) => {
                        // console.log(pages[key].offsetWidth)
                        // console.log(pages[key].scrollWidth)
                        // console.log(groups[key].offsetWidth)
                        // console.log(groups[key].scrollWidth)

                        arrow.addEventListener('click', () => {
                            if (pages[key].offsetWidth < pages[key].scrollWidth) {
                                scrolledP += pages[key].offsetWidth
                            }

                            pages[key].scroll({
                                top: 0,
                                left: scrolledP,
                                behavior: 'smooth'
                            })
                            if (scrolledP + groups[key].offsetWidth == pages[key].scrollWidth) {
                                arrow.classList.add('end')
                            }
                            if (scrolledP != 0) {
                                arrowRight[0].classList.remove('end')
                            }

                            // console.log(scrolledP)
                            // console.log(pages[key].offsetWidth)
                            // console.log(pages[key].scrollWidth)
                            // console.log(groups[key].offsetWidth)
                            // console.log(groups[key].scrollWidth)
                        })

                        arrow.addEventListener('keyup', (e) => {
                            e = e || window.KeyboardEvent
                            if (e.key === 'ArrowRight') {
                                // console.log("yes")
                                if (pages[key].offsetWidth < pages[key].scrollWidth) {
                                    scrolledP += pages[key].offsetWidth
                                }

                                pages[key].scroll({
                                    top: 0,
                                    left: scrolledP,
                                    behavior: 'smooth'
                                })
                                if (scrolledP + pages[key].offsetWidth == pages[key].scrollWidth) {
                                    arrow.classList.add('end')
                                }
                                if (scrolledP != 0) {
                                    arrowRight[0].classList.remove('end')
                                }
                            }
                        })
                    })

                    backsP.map((arrow, key) => {
                        arrow.addEventListener('click', () => {
                            if (scrolledP > 0) {
                                scrolledP -= pages[key].offsetWidth
                            }

                            pages[key].scroll({
                                top: 0,
                                left: scrolledP,
                                behavior: 'smooth'
                            })

                            if (scrolledP == 0) {
                                arrow.classList.add('end')
                            }
                            arrowLeft[0].classList.remove('end')
                        })

                        arrow.addEventListener('keyup', (e) => {
                            e = e || window.KeyboardEvent
                            if (e.key === 'ArrowLeft') {
                                if (scrolledP > 0) {
                                    scrolledP -= pages[key].offsetWidth
                                }

                                pages[key].scroll({
                                    top: 0,
                                    left: scrolledP,
                                    behavior: 'smooth'
                                })

                                if (scrolledP == 0) {
                                    arrow.classList.add('end')
                                }
                                arrowLeft[0].classList.remove('end')
                            }
                        })
                    })
                }
            }
        })
}